import "./css/app.css";
import home from "./assets/images/home.png";
import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import faqs from "./assets/faq.json";
import ReactMarkdown from 'react-markdown';
import axios from "axios";
import Footer from "./partials/Footer";
import KashimaIcon from "./assets/images/kashima.png";

export default function About() {
    const [faq, setFaq] = useState(faqs);
    const refFaq = useRef(faqs);
    const query = useRef();

    useEffect(() => {
        getFAQ().then(setFaq);
    }, [])

    function handleSearch(form, type) {
        const Query = query.current.value
        if (type === "submit") {
            form.preventDefault()
            query.current.value = "";
        }
        let result = Query ? refFaq.current.filter(x => x.question.toLowerCase().includes(Query.trim()) || x.answer.toLowerCase().includes(Query.trim()))
            : refFaq.current;

        setFaq(result)
    }

    async function getFAQ() {
        const {
            data,
            status
        } = await axios.get("https://raw.githubusercontent.com/Deivu/Kashima/master/assets/faq.json").catch(() => ({
            data: null,
            status: 500
        }));
        if(status !== 200) return;
        return data;
    }

    function handleFaq(data, index) {
        return (<div className="faq-child" key={index}>
            <div className="faq-child-title">{data.question}</div>
            <div className="faq-child-content">
                <hr/>
                <ReactMarkdown>{data.answer}</ReactMarkdown>
            </div>
        </div>)
    }


    return (<>
        <div className="header">
            <div className="header-content">
                <div className="header-application-name">
                    <img className="header-content-logo"
                         src={KashimaIcon}
                         alt="Kashima"/>
                    <p className="header-content-name">Kashima Docs</p>
                </div>
                <div className="header-search-bar">
                    <form onSubmit={x => handleSearch(x, "form")}>
                        <input ref={query} type="text" onChange={x => handleSearch(x, "change")}
                               placeholder="Search here..."/>
                    </form>
                </div>
                <Link to="/" className="header-buttons">
                    <img src={home} alt="Home"/>
                </Link>
            </div>
        </div>
        <div className="main-section faq-main-section">
            <div className="faq-title">
                <p>FAQs</p>
            </div>

            <div className="faq-section">
                {faq.length ? faq.map((x, i) => handleFaq(x, i)) : ""}
            </div>
        </div>
        <Footer/>
    </>);
}